import { showToast } from '../store/useToastStore';

export function copyLink(url) {
  const full = url.startsWith('http') ? url : 'https://' + url;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(full)
      .then(() => showToast('Link copied ✓'))
      .catch(() => showToast('Link: ' + full));
  } else {
    showToast('Link: ' + full);
  }
}
